export default class KenticoBehaviourOverrides  {

  constructor(options)
  {
   	this.options = $.extend({disableKenticoFormSubmission:false}, options);


   	if(this.options.disableKenticoFormSubmission)
   	{
   		this.disableKenticoFormSubmission();
   	}
  }

  //Disables submission of the global kentico form
  disableKenticoFormSubmission()
  {
  	$("#aspnetForm").submit((e) => this.onASPNetFormSubmission(e));
  }

  onASPNetFormSubmission(e)
  {
  	e.preventDefault();
  	e.stopPropagation();
  }
}



/** WEBPACK FOOTER **
 ** ./system/kentico-behaviour-overrides.js
 **/